export enum IdentifierType {
  MEMBER_ID = 'memberId',
  SSN = 'ssn',
  MEDICARE_ID = 'medicareId',
  MEDICAID_ID = 'medicaidId',
}

export type IdentifierTypeValue = `${IdentifierType}`;